// Shared CLEO suggestion timing. Imported by the Cloud Function path and the
// operator inbox (via src/lib/shared), so the HTTP wait, stale verdict, and
// client poll budget stay ordered: HTTP < callable = stale < poll < function
// timeout. Bump CLEO_HTTP_TIMEOUT_MS and the rest move with it.

export const CLEO_HTTP_TIMEOUT_MS = 160_000
export const CLEO_STALE_MARGIN_MS = 10_000
export const CLEO_POLL_MARGIN_MS = 5_000
export const CLEO_BACKGROUND_FUNCTION_TIMEOUT_MS = 180_000

export const CLEO_REQUEST_TIMEOUT = {
  response: CLEO_HTTP_TIMEOUT_MS,
  deadline: CLEO_HTTP_TIMEOUT_MS,
}

export const CLEO_STALE_THRESHOLD_MS =
  CLEO_HTTP_TIMEOUT_MS + CLEO_STALE_MARGIN_MS

export const CLEO_STORED_POLL_BUDGET_MS =
  CLEO_STALE_THRESHOLD_MS + CLEO_POLL_MARGIN_MS

export const CLEO_CALLABLE_TIMEOUT_MS = CLEO_STALE_THRESHOLD_MS

// How often the operator inbox re-reads a stored draft while it generates.
export const CLEO_STORED_POLL_INTERVAL_MS = 4_000
